import {
  ClientCollaboratorData,
  ClientCollaboratorsData,
} from "./components/ClientCollaboratorsForm";
import { Collaborator, PostClient } from "./types";

export function clientCollaboratorsDataToClientCollaborators(
  clientData?: ClientCollaboratorsData
): Collaborator[] | undefined {
  if (!clientData) return undefined;
  const collaborators: Collaborator[] | undefined = clientData.collaborators
    ?.map((collaborator) =>
      clientCollaboratorDataToClientCollaborator(collaborator)
    )
    .filter((collaborator) => collaborator !== undefined) as
    | Collaborator[]
    | undefined;
  return collaborators;
}
export function clientCollaboratorDataToClientCollaborator(
  clientData?: ClientCollaboratorData
): Collaborator | undefined {
  if (!clientData) return undefined;
  const clientCollaborator: Collaborator = {
    name: clientData.name ?? undefined,
    email: clientData.email ?? undefined,
    phone: clientData.phone ?? undefined,
    roles: clientData.role ? [clientData.role] : undefined,
    usinasIds: clientData.usinasIds ?? undefined,
  };
  if (
    !clientCollaborator.email &&
    !clientCollaborator.name &&
    !clientCollaborator.phone &&
    !clientCollaborator.roles &&
    !clientCollaborator.usinasIds
  ) {
    return undefined;
  }
  return clientCollaborator;
}
export function clientToClientCollaboratorsData(
  client: PostClient | null
): ClientCollaboratorsData | undefined {
  if (!client) return undefined;
  const parsedCollaborators:
    | {
        name?: string | undefined;
        email?: string | undefined;
        phone?: string | undefined;
        usinasIds?: string[] | undefined;
        roles?: string[] | undefined;
      }[]
    | undefined = client.collaboratorsList
    ?.map((collaborator) =>
      clientCollaboratorToClientCollaboratorData(collaborator)
    )
    .filter((collaborator) => collaborator !== undefined) as
    | {
        name?: string | undefined;
        email?: string | undefined;
        phone?: string | undefined;
        usinasIds?: string[] | undefined;
        roles?: string[] | undefined;
      }[]
    | undefined;

  const clientCollaboratorsData: ClientCollaboratorsData = {
    collaborators: parsedCollaborators,
  };
  return clientCollaboratorsData;
}

function clientCollaboratorToClientCollaboratorData(
  collaborator?: Collaborator
): ClientCollaboratorData | undefined {
  if (!collaborator) return undefined;
  const clientCollaboratorData: ClientCollaboratorData = {
    name: collaborator.name,
    email: collaborator.email,
    phone: collaborator.phone,
    role:
      collaborator.roles && collaborator.roles.length > 0
        ? collaborator.roles[0]
        : undefined,
    usinasIds: collaborator.usinasIds,
  };
  return clientCollaboratorData;
}
